import { 
    Pipe, 
    PipeTransform
}                             from "@angular/core";
import { textDateLocale }     from "../functions";
  
@Pipe({ name: "ctmDate" })
export class CtmDatePipe implements PipeTransform {
    transform(value: Date, format = "DD/MM/YYYY", locale = null):string {
      return textDateLocale(value, format, locale);
    }
}
  


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/_common/pipes/date.pipe.ts